// import external dependencies
import $ from 'jquery';
// Import everything from autoload
import '../styles/main.scss';

import './autoload/index';
import './modules/app.setpar';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import single from './routes/single';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  single,
});

// Load Events
$(document).ready(() => {
  routes.loadEvents();

  // Fechar navbar quando clica em um dos items do menu
  $('.navbar-nav>li>a')
    .not('.dropdown-toggle')
    .on('click', function() {
      $('.navbar-collapse').collapse('hide');
    });

  window.openChatSetpar = () => {
    const chatButton = $('.AtendimentoBtn');
    if (chatButton) {
      chatButton.trigger('click');
    }
  };
});
